module.exports = __webpack_public_path__ + "static/media/IconModalAcessoPerfis.987e2aa1.svg";